import { ColourPalette } from '@repo/types'
import { Label } from '@repo/ui'
import { useField } from 'formik'
import { observer } from 'mobx-react-lite'

interface ColorPaletteSelectorProps {
  onChange: (value: ColourPalette) => void
  selectedValue?: ColourPalette
}

export const ColorPaletteSelector = observer(function ColorPaletteSelector({
  onChange,
  selectedValue
}: ColorPaletteSelectorProps) {
  return (
    <fieldset className='flex gap-2'>
      {getColourOptions().map((option: string) => (
        <div key={option}>
          <input
            checked={selectedValue === option}
            className='peer hidden'
            id={option}
            name='colour'
            type='radio'
            value={option}
            onChange={event => onChange(event.target.value as ColourPalette)}
          />

          <Label
            className='flex size-12 rounded border-white peer-checked:border-4'
            htmlFor={option}
            style={{ backgroundColor: `var(--${option.toLowerCase()}-500)` }}
          />
        </div>
      ))}
    </fieldset>
  )
})

function getColourOptions(): string[] {
  const colourOptions: string[] = []

  for (const colour in ColourPalette) {
    const colourOption: ColourPalette = ColourPalette[colour as keyof typeof ColourPalette]
    colourOptions.push(colourOption)
  }
  return colourOptions
}

export const ColourPaletteField = observer(function ColourPaletteField() {
  const [field] = useField('colour')

  return (
    <ColorPaletteSelector selectedValue={field.value as ColourPalette} onChange={field.onChange} />
  )
})
